import React, { useEffect, useState } from 'react';
import { Drawer, List, ListItemText, ListItemButton, Collapse, IconButton, Box, Divider, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { HeaderSiteRedeSocial } from './HeaderSiteRedeSocial';
import configSiteUrls from '../../configs/configSiteUrls';
import { MenuSitePaiListDTO, MenuSiteFilhoListDTO, MenuSiteNetoListDTO } from '../../../../typesSite/menuPrincipalSite/MenuSiteListDTO';
import { useGetPublicMenusQuery } from '../../features/menus/menuPai/menuPaiApiSlice';
import { setMenu, setMenuLayout } from '../../features/menus/menuPrincipalSite/menuPrincipalSiteSlice';
import { UsuarioAdminSite } from '../../../../utils/usuarioEstaLogado';

type MobileMenuDrawerProps = {
  layout: 'site' | 'escolaLegislativo';
}

export const MobileMenuDrawer: React.FC<MobileMenuDrawerProps> = ({ layout }) => {
  const dispatch = useAppDispatch();
  const menuSite = useAppSelector(state => state.menuPrincipalSite).menu;
  const menuLayoutSlice = useAppSelector(state => state.menuPrincipalSite).layout;

  const { data, error, isLoading, isFetching, refetch } = 
  useGetPublicMenusQuery({ escolaLegislativo: layout === 'escolaLegislativo' }, {
    skip: menuSite.length > 0 && menuLayoutSlice === layout,
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false
  });

useEffect(() => {
  if (data) {
    dispatch(setMenu(data));
    dispatch(setMenuLayout(layout));
  }
}, [data, dispatch, layout]);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expandedPaiIndex, setExpandedPaiIndex] = useState<number | null>(null);
  const [expandedFilhoKey, setExpandedFilhoKey] = useState<string | null>(null);
const usuarioAdminSite = UsuarioAdminSite();
  const toggleDrawer = (state: boolean) => () => {
    setDrawerOpen(state);
    if (!state) {
      setExpandedPaiIndex(null);
      setExpandedFilhoKey(null);
    }
  };

  const handleTogglePai = (index: number) => {
    setExpandedPaiIndex(prev => (prev === index ? null : index));
    setExpandedFilhoKey(null);
  };

  const handleToggleFilho = (paiIndex: number, filhoIndex: number) => {
    const key = `${paiIndex}-${filhoIndex}`;
    setExpandedFilhoKey(prev => (prev === key ? null : key));
  };

  const handleNavigate = (link?: string | null, noticiaId?: string | null) => {
    const url = noticiaId ? `${configSiteUrls.SITE_NOTICIA_PUBLIC_VIEW_LK}${noticiaId}` : link;
    if (url) window.open(url, '_self');
    setDrawerOpen(false);
  };

  return (
    <>
      <IconButton onClick={toggleDrawer(true)} sx={{ display: { xs: 'block', md: 'none' }, color: 'inherit' }}>
        <MenuIcon />
      </IconButton>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 280 }} role="presentation">
          {/* Topo */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
            <Typography variant="h6">Menu</Typography>
            <IconButton onClick={toggleDrawer(false)}>✕</IconButton>
          </Box>

          <HeaderSiteRedeSocial />
          <Divider />

          <List>
            {menuSite.map((menuPai: MenuSitePaiListDTO, paiIndex) => {
                
                const podeExibir = menuPai.label.toUpperCase() === 'ADM' ? usuarioAdminSite : true;
                if (!podeExibir) return null;



             return( 
              <React.Fragment key={paiIndex}>
                {menuPai.filhos && menuPai.filhos.length > 0 ? (
                  <>
                    <ListItemButton onClick={() => handleTogglePai(paiIndex)}>
                      <ListItemText primary={menuPai.label} />
                      {expandedPaiIndex === paiIndex ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse in={expandedPaiIndex === paiIndex} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {menuPai.filhos.map((menuFilho: MenuSiteFilhoListDTO, filhoIndex) => {
                          const filhoKey = `${paiIndex}-${filhoIndex}`;
                          const temNeto = !!menuFilho.netos && menuFilho.netos.length > 0;

                          return (
                            <React.Fragment key={filhoKey}>
                              <ListItemButton onClick={() => (temNeto ? handleToggleFilho(paiIndex, filhoIndex) : handleNavigate(menuFilho.link, menuFilho.noticiaId))} sx={{ pl: 4 }}>
                                <ListItemText primary={menuFilho.label} />
                                {temNeto && (expandedFilhoKey === filhoKey ? <ExpandLess /> : <ExpandMore />)}
                              </ListItemButton>

                              {temNeto && (
                                <Collapse in={expandedFilhoKey === filhoKey} timeout="auto" unmountOnExit>
                                  <List component="div" disablePadding>
                                    {menuFilho.netos?.map((menuNeto: MenuSiteNetoListDTO, netoIndex) => (
                                      <ListItemButton key={`${filhoKey}-${netoIndex}`} onClick={() => handleNavigate(menuNeto.link, menuNeto.noticiaId)} sx={{ pl: 6 }}>
                                        <ListItemText primary={menuNeto.label} />
                                      </ListItemButton>
                                    ))}
                                  </List>
                                </Collapse>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </List>
                    </Collapse>
                  </>
                ) : (
                  <ListItemButton onClick={() => handleNavigate(menuPai.link, menuPai.noticiaId)}>
                    <ListItemText primary={menuPai.label} />
                  </ListItemButton>
                )}
              </React.Fragment>
             )}
            )}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
